import "@/App.css";
import { Instagram } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Menu } from "@/components/Menu";
import { HowToOrder } from "@/components/HowToOrder";
import { Payments } from "@/components/Payments";
import { Reviews } from "@/components/Reviews";
import { InstagramFeed } from "@/components/InstagramFeed";
import { About } from "@/components/About";
import { OrderForm } from "@/components/OrderForm";
import { Footer } from "@/components/Footer";
import { OrdersAdmin } from "@/components/OrdersAdmin";
import { BUSINESS } from "@/lib/business";
import { CartProvider } from "@/context/CartContext";

function App() {
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/orders")) {
    return <OrdersAdmin />;
  }
  return (
    <CartProvider>
    <div className="App bg-cream min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Menu />
        <HowToOrder />
        <Payments />
        <Reviews />
        <InstagramFeed />
        <About />
        <OrderForm />
      </main>
      <Footer />

      <a
        href={BUSINESS.instagramUrl}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-instagram"
        aria-label="Order on Instagram"
        className="fixed bottom-6 right-6 z-50 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg bg-gradient-to-tr from-[#feda75] via-[#d62976] to-[#4f5bd5] hover:scale-105 transition-transform"
      >
        <Instagram size={26} />
      </a>

      <Toaster position="top-center" richColors />
    </div>
    </CartProvider>
  );
}

export default App;
